<template>
  <div>
    <div v-if="showReportsList" class="reportsList">
      <v-data-table
        :headers="this.reportListHeaders"
        :items="this.reportList"
        :items-per-page="-1"
        item-key="ReportId"
        @click:row="onSelectReport"
        :loading="loading"
      >
        <template v-slot:loading>
          <v-skeleton-loader type="table-row@10" />
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>Set Parameters</v-card-title>

          <v-card-text>
            <div v-for="input in reportInputs" :key="input.Name">
              <div v-if="input.Type == 'int'">
                <v-text-field
                  type="number"
                  :label="input.Title"
                  v-model="input.Value"
                ></v-text-field>
              </div>
              <div v-else-if="input.Type == 'Date'">
                <DatePicker :label="input.Title" v-model="input.Value"></DatePicker>
              </div>
              <div v-else-if="input.Type == 'List'">
                <v-select
                  :label="input.Title"
                  :items="input.ListItems"
                  item-text="Text"
                  item-value="Value"
                  v-model="input.Value"
                ></v-select>
              </div>
              <div v-else>
                <v-text-field :label="input.Title" v-model="input.Value"></v-text-field>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-btn @click="closeDialog" color="blue darken-1">Cancel</v-btn>
            <v-btn @click="runInvestmentReport" color="blue darken-1">Run</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div v-else>
      <div class="investmentReport">
        <v-row>
          <v-col cols="auto">
            <h2 class="px-2">{{ selectedReport.Title }}</h2>
          </v-col>
          <v-col cols="auto">
            <div class="btnContainer px-2">
              <v-btn outlined color="primary" class="mr-4" @click="exportResults"
                >Export Results</v-btn
              >
              <v-btn outlined color="primary" class="mr-4" @click="onBackToList"
                >Back to List</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <div v-if="DataSet2 && DataSet2.length" class="dataset2">
          <v-container>
            <v-row>
              <v-col cols="2">
                <v-text-field
                  label="Date"
                  :value="new Date().toISOString().slice(0, 10)"
                  readonly
                  disabled
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-text-field
                  label="Date Invested"
                  :value="new Date(DataSet2[0].InvestDate).toISOString().slice(0, 10)"
                  readonly
                  disabled
                  dense
                  persistent-placeholder
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="Description"
                  :value="DataSet2[0].Description"
                  readonly
                  disabled
                  dense
                  persistent-placeholder
                  placeholder=" "
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  label="Plan"
                  :value="DataSet2[0].Name"
                  readonly
                  disabled
                  dense
                  persistent-placeholder
                  placeholder=" "
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  label="Payroll"
                  :value="DataSet2[0].Payroll"
                  readonly
                  disabled
                  dense
                  persistent-placeholder
                  placeholder=" "
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  label="Status"
                  :value="DataSet2[0].Status"
                  readonly
                  disabled
                  dense
                  persistent-placeholder
                  placeholder=" "
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div class="tableContainer">
          <v-data-table
            :headers="DataSet1Headers"
            :items="DataSet1"
            :items-per-page="-1"
            :loading="loading"
            class="w-100"
            dense
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10" />
            </template>
          </v-data-table>
        </div>

        <v-spacer></v-spacer>

        <div v-if="DataSet3" class="tableContainer">
          <v-data-table
            :headers="DataSet3Headers"
            :items="DataSet3"
            :items-per-page="-1"
            :loading="loading"
            class="w-100"
            dense
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10" />
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import InvestmentReport from '@/views/Investments/InvestmentReport.vue';
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  name: 'InvestmentReports',
  components: {
    //InvestmentReport,
    DatePicker,
  },
  props: {
    reportType: {
      type: String,
      default: '',
    },
    investRunId: {
      type: Number,
      default: 0,
    },
    investRunUID: {
      type: String,
      default: '00000000-0000-0000-0000-000000000000',
    },
    setParams: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      reportListHeaders: [
        { text: 'Report Name', value: 'Title' },
        { text: 'Description', value: 'Description' },
      ],
      reportList: [],
      selectedReport: {},
      options: [],
      dialog: false,
      loading: false,
      showReportsList: true,
      reportData: [],
      reportDetails: {},
      reportInputs: [],
      DataSet1: [],
      DataSet2: [],
      DataSet3: [],
    };
  },

  mounted() {
    console.log('reportType:' + this.reportType);
    this.getReportsList();
  },

  computed: {
    DataSet1Headers() {
      if (!this.DataSet1 || !this.DataSet1.length) return [];
      return Object.keys(this.DataSet1[0]).map((key) => ({
        text: key,
        value: key,
      }));
    },
    DataSet2Headers() {
      if (!this.DataSet2 || !this.DataSet2.length) return [];
      return Object.keys(this.DataSet2[0]).map((key) => ({
        text: key,
        value: key,
      }));
    },
    DataSet3Headers() {
      if (!this.DataSet3 || !this.DataSet3.length) return [];
      return Object.keys(this.DataSet3[0]).map((key) => ({
        text: key,
        value: key,
      }));
    },
    planId() {
      return this.$store.getters.currentPlanId;
    },
  },

  methods: {
    onSelectReport(item) {
      this.selectedReport = item;
      if (this.setParams) {
        this.openParamDialog(item);
      } else {
        this.runInvestmentReport();
      }
    },

    openParamDialog() {
      this.dialog = true;
      this.getReportParams();
    },

    async getReportParams() {
      try {
        this.reportInputs = [];
        const reportId = this.selectedReport.ReportId;
        let response = await this.$api.get(`/reportservice/getreportinputs?reportId=${reportId}`);
        let data = response.data;

        this.reportInputs = data._inputList.map((input) => ({
          ReportId: input._ReportId,
          Name: input._Name,
          Title: input._Title,
          Type: input._Type,
          ListItems: [],
          DefaultValue: '',
          Value: '',
        }));

        const listPromises = this.reportInputs.map(async (input) => {
          if (input.Type == 'List') {
            try {
              const listItemsResponse = await this.$api.get(
                `/ReportService/GetReportParamListItems`,
                {
                  params: {
                    reportName: this.selectedReport.Name,
                    paramName: input.Name,
                    defaultValue: input.DefaultValue,
                    planId: this.planId,
                  },
                }
              );
              input.ListItems = listItemsResponse.data;
            } catch (err) {
              console.error(err);
              input.ListItems = [];
            }
          }

          return input;
        });

        this.reportInputs = await Promise.all(listPromises);
      } catch (err) {
        console.log(err);
      }
    },

    async getReportsList() {
      try {
        this.loading = true;
        const reportType = !this.reportType ? '' : this.reportType;
        let response = await this.$api.get(
          `/reportservice/GetServerReportList?reportType=${reportType}`
        );

        this.reportList = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async getReportData() {
      try {
        this.loading = true;
        const params = {};

        params['ReportName'] = this.selectedReport.Name;

        if (this.investRunId > 0) {
          params['InvestRunId'] = this.investRunId;
          params["UID"] = this.investRunUID;
        } else {
          this.reportInputs.forEach((input) => {
            if (input.Name && input.Value !== undefined) {
              params[input.Name] = input.Value;
            }
          });
        }

        let response = await this.$api.get(`/ReportService/GetReportDatabyId`, { params: params });

        let data = response.data;

        this.DataSet1 = data['DataSet1'];
        this.DataSet2 = data['DataSet2'];
        this.DataSet3 = data['DataSet3'];

        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    closeDialog() {
      this.dialog = false;
    },

    runInvestmentReport() {
      this.closeDialog();
      this.showReportsList = false;
      this.getReportData();
    },

    onBackToList() {
      this.showReportsList = true;
      this.selectedReport = {};
      this.reportData = [];
      this.reportDetails = {};
      this.reportInputs = [];
      this.DataSet1 = [];
      this.DataSet2 = [];
      this.DataSet3 = [];
    },

    async exportResults() {
      try {
        const params = {
          reportTitle: this.selectedReport.Title,
          datasets: {
            DataSet1: this.DataSet1,
            DataSet2: this.DataSet2,
            DataSet3: this.DataSet3,
          },
        };
        let response = await this.$api.post('/ReportService/ExportReportToExcel', params, {
          responseType: 'blob',
        });

        // Create a link to download the file
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.selectedReport.Title}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btnContainer {
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 12px;
  margin-top: 12px;
  width: 100%;
  display: flex;
}

.tableContainer {
  margin: 20px;
  padding: 30px;
  width: 100%;
}

.v-data-table {
  width: 100%;
}

h2 {
  margin: 15px;
}
</style>
